<template>
	<!-- generateVariantStyle() permet de générer les variables Css dynamique utilisable dans la section <style></style> -->
	<b-row class="w-100 h-100 p-0 m-0 no-gutters position-relative" :style="generateVariantStyle(Variant)">
		<b-col class="h-100" style="margin-left: 75px;">
			<b-overlay :show="showOverlay" no-center class="d-flex flex-column h-100 w-100" z-index="0">
				<!-- Overlay quand aucune fonction de chargée -->
				<template #overlay>
					<Welcome :DisplayBrand="false" :Loading="false" :Variant="Variant">
						<template v-slot:MiscContent>
							<h4 class="text-center">{{$t('PleaseSelectAFunction')}}</h4> <!-- Veuillez sélectionner une fonction -->
						</template>
					</Welcome>
				</template>

				<!-- Chargement de la fonction d'administration -->
				<component v-bind:is="target" :Action="action" :Interop="target ==='IFrameLoader' ? 'Administrator/' + featureName : ''" :Link="target ==='IFrameLoader' ? 'Administration/' + featureName + '_Page.aspx' : ''" :Variant="Variant" />
			</b-overlay>
		</b-col>
		<!--Colonne paramètres Administration (colonne tout à gauche) -->
		<!--SCROLL QUE SUR LA LISTE, PAS SUR LA PAGE ENTIERE-->
		<b-col v-b-hover="setFullSizeSideBar" cols="auto" xs="auto" sm="auto" md="auto" lg="auto" xl="auto" style="z-index: 200;" class="h-100 z-3 px-3 position-absolute">
			<b-card-group deck class="h-100  overflow-auto">
				<b-card no-body class="font-weight-bold d-flex flex-column mh-100 h-100 m-0 p-0" :style="isFullSideBar ? '' : 'overflow-x: hidden; scrollbar-width: thin;'">
					<b-list-group id="adminList">
						<!-- Occurence des fonctions administrateur pour la création de la sidebar -->
						<b-list-group-item v-for="item in adminFeatures" v-bind:key="item.Name" href="#" 
							:disabled="item.Disabled"
							@click="target = item.Target; action = item.Action; featureName = item.Name; showOverlay = false;"
							class="flex-column justify-content-center"
							:class="{ 'activeFeature': featureName === item.Name }">
							<b-row>
								<b-col cols="12" class="d-flex justify-content-center pl-0 pr-2">
									<b-col :cols="1" class="d-flex justify-content-center align-items-center">
										<!-- Affichage de l'icone-->
										<component v-bind:is="item.IconType" :icon="item.Icon" class="h6 m-0"/>
										<!-- Affichage des badges (new, beta) lorsque la sidebar est au minimum -->
										<b-badge v-if="!isFullSideBar && item.Disabled" :variant="Variant">Beta</b-badge>
										<b-badge v-if="!isFullSideBar && item.New" :variant="featureName === item.Name ? Variant + '-dark' : Variant">New</b-badge>
									</b-col>
									<!-- Transition pour le déploiement de la sidebar lors d'un hover-->
									<Transition name="setFull">
										<!--d-none d-sm-block permet de masquer le texte pour les ecrans de petites tailles (smartphones)-->
										<b-col v-if="isFullSideBar && !($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm')" cols="11" class="d-flex pr-3">
											{{ item.Text }}
											<b-badge v-if="item.Disabled" :variant="Variant" class="mr-4">Beta</b-badge>
											<b-badge v-if="item.New" :variant="featureName === item.Name ? Variant + '-dark' : Variant" class="mr-4">{{ $t('New') }}</b-badge>
										</b-col>
									</Transition>
								</b-col>
							</b-row>
						</b-list-group-item>
					</b-list-group>
				</b-card>
			</b-card-group>
		</b-col>
	</b-row>
</template>

<script lang="ts">
	import { Component, ProvideReactive, Vue } from 'vue-property-decorator';
	import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
	import { API_URL } from '@/App.settings';
	import axios from 'axios';

	/** Composants d'administration V3 */
	import ObjectDashAdmin from './Administration/ObjectDashAdmin.vue';
	import Personalization from './Administration/Personalization.vue';
	import Factors from './Administration/Factors.vue';
	import UsersManager from './Administration/UsersManager.vue';
    import ChartParams from "@/components/MasterPage/Administration/ChartParams.vue";
    import FactorCalendar from '@/components/commons/Factors/FactorCalendar.vue';
	import ReportDesigner from './Administration/ReportDesigner.vue';
	import CertificateAdministration from './Administration/CertificateAdministration.vue';
    import OperatParameter from "./Administration/OperatParameter.vue";
	import Profil from '../commons/Profil.vue';

	/** Pour chargement des fonctions d'administration de la V2 */
	import IFrameLoader from "@/components/commons/IFrameLoader.vue";

	import Welcome from '@/components/commons/Welcome.vue';
	import Feature from '@/types/Feature';
	import { ThemeUtils } from '@/components/commons/Utils';

	import locales from './locales/Administration.json';
	
	/** Composant d'accès aux fonctions d'administration */
	@Component({
		components: {
			FontAwesomeIcon,
			Welcome,

			/** Gestion des utilisateurs */
			UsersManager,

			/** Administration des widgets */
			ObjectDashAdmin,

			/** Personnalisation */
			Personalization,

			/** Facteurs d'influence */
			Factors,
            FactorCalendar,

			/** Designer de rapports */
			ReportDesigner,

            /** Paramétrage des graphiques */
            ChartParams,

            /** Paramétrage pour OPERAT et la récupération des déclarations */
            OperatParameter,

			/** Profile */
			Profil,

			/** Composant IFrame de chargement des fonctions V2 */
			IFrameLoader,

			/** Gestion des certificats distributeur */
			CertificateAdministration
		},
		i18n: { messages : locales}
	})
	export default class Administration extends ThemeUtils {
		/** Variant de couleur à appliquer sur les fonctions d'Administration */
		@ProvideReactive()
        protected Variant: string = "quartary";

		private target: string = "";
		private action: string = "";
		private featureName: string = ""
		private isFullSideBar: boolean = false;
		private showOverlay: boolean = true;

		/** Librairie de paramètres sélectionnables dans la partie Administration */
		/**remplacer key par id*/
		private adminFeatures: AdminFeature[] = [];

		private setFullSizeSideBar(isHovered){
			this.isFullSideBar = isHovered;
		}

		async created() {
			var data = {
				token: Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : ""
			};

			await axios.post<AdminFeature[]>(API_URL + "navigation/getAdminFeatures", data).then((response) => {
				if (response && response.data) {
					this.adminFeatures = response.data;
				}
			})
			.catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
		}
	}

	interface AdminFeature extends Feature{
		Text: string,
		/** font-awesome-icon (fontawesome) ou b-icon (bootstrap icon) 
		 * @todo Utiliser plutôt un enum ?
		*/
		IconType: string,
		New: boolean
	}
</script>

<style scoped>
	.activeFeature {
		background-color: var(--Variant) !important;
		color: white !important;
		font-weight: bold !important;
	}

	.list-group-item.disabled {
		color: silver !important;
	}

	.setFull-enter-active {
		transform-origin:left center;
 		animation: bounce-in 0.2s;
	}
	
	.setFull-leave-active {
		transform-origin:left center;
		animation: bounce-in 0.1s reverse;
	}

	@keyframes bounce-in {
		0% {
			transform: scaleX(0);
		}
		
		100% {
			transform: scaleX(1);
		}
	}
	.badge{
		position: absolute;
		bottom: -5px;
		right: -20px;
		display: block;
	}

	/** Réduction largeur scrollbar pour le menu d'administration adminList */
	#adminList::-webkit-scrollbar {
		width: 10px;
	}
</style>